export const disposableMasksFormFields = [
    { name: 'name', type: 'text' as const, placeholder: 'Your Name*', required: true },
    { name: 'company', type: 'text' as const, placeholder: 'Company Name*', required: true },
    { name: 'email', type: 'email' as const, placeholder: 'Company Email*', required: true },
    { name: 'phone', type: 'tel' as const, placeholder: 'Phone*', required: true },
    { 
        name: 'mask_needed', 
        type: 'select' as const, 
        placeholder: 'Mask Type',
        options: [
            { value: '3-Ply Face Mask - Light Blue', label: '3-Ply Face Mask - Light Blue' },
            { value: '3-Ply Face Mask - Black', label: '3-Ply Face Mask - Black' },
            { value: 'KN95 Face Mask – White', label: 'KN95 Face Mask – White' },
            { value: 'KN95 Face Mask – Black', label: 'KN95 Face Mask – Black' }
        ]
    },
    { 
        name: 'quantity', 
        type: 'select' as const, 
        placeholder: 'Quantity',
        options: [
            { value: '500 (minimum)', label: '500 (minimum)' },
            { value: '1,000', label: '1,000' },
            { value: '5,000', label: '5,000' },
            { value: '10,000', label: '10,000' },
            { value: '50,000', label: '50,000' },
            { value: 'Over 100,000', label: 'Over 100,000' },
            { value: 'Quantity Not Listed', label: 'Quantity Not Listed' }
        ]
    }
]; 